export default __webpack_public_path__ + "static/media/phone.f05b229b.png";